module.exports = __webpack_public_path__ + "img/device-11.60efaa61.png";